'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatasetModule = exports.EventsModule = exports.HeroModule = exports.AttrsModule = exports.PropsModule = exports.ClassModule = exports.StyleModule = undefined;

var _class = require('snabbdom/modules/class');

var _class2 = _interopRequireDefault(_class);

var _props = require('snabbdom/modules/props');

var _props2 = _interopRequireDefault(_props);

var _attributes = require('snabbdom/modules/attributes');

var _attributes2 = _interopRequireDefault(_attributes);

var _eventlisteners = require('snabbdom/modules/eventlisteners');

var _eventlisteners2 = _interopRequireDefault(_eventlisteners);

var _style = require('snabbdom/modules/style');

var _style2 = _interopRequireDefault(_style);

var _hero = require('snabbdom/modules/hero');

var _hero2 = _interopRequireDefault(_hero);

var _dataset = require('./dataset');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [_style2.default, _class2.default, _props2.default, _attributes2.default];
exports.StyleModule = _style2.default;
exports.ClassModule = _class2.default;
exports.PropsModule = _props2.default;
exports.AttrsModule = _attributes2.default;
exports.HeroModule = _hero2.default;
exports.EventsModule = _eventlisteners2.default;
exports.DatasetModule = _dataset.DatasetModule;


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/modules/index.js
 **/